import React from 'react';

export const SponsorTricareAddtlInfo = () => (
  <va-details label="What to know about TRICARE eligibility">
    <p>
      TRICARE is the Defense Department’s healthcare program for service members
      and their families. Your uniformed service decides who’s eligible for
      TRICARE. And it gets reported in the Defense Enrollment Eligibility System
      (DEERS).
    </p>
    <p>
      Even if you aren’t enrolled, you can’t get CHAMPVA benefits if you’re
      eligible for TRICARE.
    </p>
    <va-link
      text="Check your eligibility on the TRICARE website"
      href="https://tricare.mil/Plans/Eligibility"
      external
    />
  </va-details>
);

export const OtherTricareAddtlInfo = () => (
  <va-details label="What to know about TRICARE eligibility">
    <p>
      The Veteran’s uniformed service decides who is eligible for TRICARE. And
      it gets reported in the Defense Enrollment Eligibility System (DEERS).
    </p>
    <va-link
      text="Check if the Veteran is eligible on the TRICARE website"
      href="https://tricare.mil/Plans/Eligibility"
      external
    />
  </va-details>
);
